import React from 'react'
import { Footer } from '../../components/footer';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import moment from 'moment';
import PropTypes from 'prop-types';


const UpgradeWalletHistory = ({ userHistory, page, setPage, rowsPerPage, setRowsPerPage }) => {
   
 
    const totalPages = Math.ceil(userHistory?.data[0]?.pagination?.total / rowsPerPage);

    const handlePageChange = (newPage) => {
        const currentScrollY = window.scrollY;

        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
            window.requestAnimationFrame(() => {
                window.scrollTo(0, currentScrollY);
            });
        }
    };
    return (
        <>
            <div>
                <div>
                    <div className='container'>
                        <div className="row">
                            <div className="col-12">
                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div className="cardHeader border-bottom-0 d-flex justify-content-between flex-wrap px-4 pb-0">
                                        <div className='bxTitle'>
                                            <span>Top-up Level History</span>
                                        </div>
                                    </div>
                                    <div className="px-4 mb-3">
                                        <div className='row justify-content-between'>
                                            <div className="col-md-6 mb-2 mb-md-0 text-center text-md-left">
                                                <div className='d-inline-flex g-8 align-items-center'>
                                                    <span className='fs-18 fw-400 text-white-60'>Show</span>
                                                    <div className='form-group mb-0 formInputs gradientBg'>
                                                        <select className='form-control' onChange={(e) => {
                                                            setRowsPerPage(Number(e.target.value));
                                                            setPage(0);
                                                        }}>
                                                            <option value="10">10</option>
                                                            <option value="30">30</option>
                                                            <option value="50">50</option>
                                                        </select>
                                                    </div>
                                                    <span className='fs-18 fw-400 text-white-60'>entries</span>
                                                </div>
                                            </div>
                                           
                                        </div>
                                    </div>
                                    <div className='table-responsive mb-3'>
                                        <table className='table myapptable table-hover table-borderless mb-0'>
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>

                                                    <th className='pl-4'>Level</th>
                                                    <th>Amount</th>
                                                    <th className='pl-4'>User Id</th>
                                                    <th>Username</th>
                                                    <th>Type</th>

                                                    <th>Date & Time</th>
                                                    <th className='text-right pr-4'>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                               
                                                {
                                                    userHistory?.data[0] && userHistory?.data[0]?.data?.length > 0 ? (
                                                        userHistory?.data[0]?.data?.map((v, i) => (
                                                            <tr key={v?._id}>
                                                                <td>{page * rowsPerPage + (i + 1)}</td>
                                                                <td className='pl-4 text-nowrap'>Level {Number(v?._id) + 1}</td>
                                                                <td>{parseFloat(v?.amount).toFixed(3)}</td>
                                                                <td className='pl-4'>{!v?.userId || v.userId.length === 0 || v.userId[0] === "" ? "Admin" : v.userId}</td>
                                                                <td className='pl-4'>{!v?.username || v.username.length === 0 || v.username[0] === "" ? "Admin" : v.username}</td>
                                                                <td >
                                                                {!v?.amountInType || v.amountInType.length === 0 || v.amountInType[0] === "UserUpgradeCommission" ? "Manual" : 'Auto'}
                                                                </td>

                                                                <td className='pr-4 text-nowrap'>
                                                                    <span>{moment(v.date).format("DD/MM/YYYY | hh:mm A")}</span>
                                                                </td>
                                                                <td className='text-right pr-4'> <span className="text-lightgreen">Completed</span></td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="8" className="text-center">No data found</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="px-4">
                                        <div className='row'>
                                            
                                            <div className='col-lg-12'>
                                                <Pagination aria-label="Page navigation" className='customPagination'>

                                                    <PaginationItem disabled={page === 0}>
                                                        <PaginationLink previous href="#" onClick={() => handlePageChange(page - 1)} className='prevbtn'>
                                                            <i className='bi bi-arrow-left align-bottom'></i> Previous
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                    <span className='number'>
                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                            <PaginationItem key={index} active={index === page}>
                                                                <PaginationLink href="#" onClick={() => handlePageChange(index)}>
                                                                    {index + 1}
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        ))}

                                                    </span>

                                                    <PaginationItem disabled={page === totalPages - 1}>
                                                        <PaginationLink next href="#" onClick={() => handlePageChange(page + 1)} className='nextbtn'>
                                                            Next <i className='bi bi-arrow-right align-bottom'></i>
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                </Pagination>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}
UpgradeWalletHistory.propTypes = {
    userHistory: PropTypes.shape({
        data: PropTypes.arrayOf(
          PropTypes.shape({
            data: PropTypes.array.isRequired,
            pagination: PropTypes.shape({
              total: PropTypes.number.isRequired
            }).isRequired
          }).isRequired
        ).isRequired
      }).isRequired,
    setRowsPerPage: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  };
export default UpgradeWalletHistory;